// src/components/Benefits/Benefits.js

import React from "react";
import "./Benfits.css";

import {
  FaLeaf,
  FaShieldAlt,
  FaHeartbeat
} from "react-icons/fa";

function Benefits() {
  const benefitsData = [
    {
      icon: <FaLeaf />,
      color: "#2E7D32",
      title: "Safest Medicine",
      desc: "Homeopathic medicines are gentle, natural and suitable for all age groups when professionally guided."
    },
    {
      icon: <FaHeartbeat />,
      color: "#E53935",
      title: "No Side Effects",
      desc: "A natural healing approach designed to support the body without harsh chemical reactions."
    },
    {
      icon: <FaShieldAlt />,
      color: "#1565C0",
      title: "Improves Immunity",
      desc: "Supports internal balance and helps strengthen the body’s natural defense system."
    }
  ];

  return (
    <section className="benefits-section">

      <div className="benefits-top-bg"></div>

      <div className="benefits-wrapper">

        {/* <p className="benefits-tag">
          WHY CHOOSE ROOTLY
        </p> */}

        <h2>
          Benefits of <br /> Homeopathic Medicine
        </h2>

        <p className="benefits-subtitle">
          Natural healing approach focused on safe and long-term wellness
        </p>

        <div className="benefits-grid">

          {benefitsData.map((item, index) => (
            <div className="benefit-card" key={index}>

              <div
                className="benefit-icon"
                style={{
                  color: item.color,
                  background: `${item.color}15`
                }}
              >
                {item.icon}
              </div>

              <h3>{item.title}</h3>

              <p>{item.desc}</p>

            </div>
          ))}

        </div>

      </div>

    </section>
  );
}

export default Benefits;